const NAVBAR = () => {
  return (
    <>
      <div className="footer">&copy; 2024 TO DO APP | All Rights Reserved.</div>
    </>
  );
};
export default NAVBAR;
